import { useNavigate } from "react-router-dom"
import { CapitalizeFirstLowercaseRest } from "../../../Helpers/CustomConverter"
import useCommonFunctions from "../../../Pages/Shop/Hooks/MobileAndDesktopCommon/useCommonFunctions"
import { useAuth } from "../../../Providers/AuthProvider"
import { useShop } from "../../../Providers/ShopProvider"
import useGetProductImage from "../../../Hooks/useGetProductImage"
import { IoCartOutline } from 'react-icons/io5';
import { useCart } from "../../../Providers/CartProvider"
import { useOffers } from "../../../Providers/OffersProvider"


const TopBarMobileSearchingResults = ({ phrases, products, suppliers, categories, textSearch, handleSearch, searchingProductRef, setHideProductList }) => {
    const navigate = useNavigate()
    const { handleCategoryClick, handleSupplierClick, handleProductInQueryClick } = useCommonFunctions()
    const { wholesalePrices } = useAuth()
    const { productsFilter } = useShop()

    const handleElementClick = (link) => {
        setHideProductList(true)
        navigate(link)
    }

    var allArticleButtonStyle = productsFilter.AllArticles ? 'btn-app-primary' : 'btn-app-secondary'

    return (
        <div className="mobile-top-bar-searching-result-holder pb-3" ref={searchingProductRef}>
            <div className="row ps-3">
                <ListItemKeyWords
                    phrases={phrases}
                    handleElementClick={handleElementClick}
                />
            </div>
            <div className="row ps-3 mt-2">
                <Products
                    products={products}
                    wholesalePrices={wholesalePrices}
                    handleProductInQueryClick={handleProductInQueryClick}
                    setHideProductList={setHideProductList}
                />
            </div>
            <div className="row ps-3 mt-2">
                <Categories
                    categories={categories}
                    textSearch={textSearch}
                    handleCategoryClick={handleCategoryClick}
                    setHideProductList={setHideProductList}
                />
            </div>
            <div className="row ps-3 mt-2">
                <Suppliers
                    suppliers={suppliers}
                    handleSupplierClick={handleSupplierClick}
                    textSearch={textSearch}
                    setHideProductList={setHideProductList}
                />
            </div>
            <div className="row ps-5 pe-5 mt-3">
                <button className={allArticleButtonStyle} onClick={() => handleSearch(null, true)}>Dodaj bazę produktów na zamówienie</button>
            </div>
        </div>
    )
}

const ListItemKeyWords = ({ phrases, handleElementClick }) => {
    return (<>
        <div className="row mt-2 mb-2 align-items-center secondary-text">
            <div className="col-auto">
                <span className="" style={{ fontWeight: 'bold', fontSize: '25px' }}>Grupa towarowa</span>
            </div>
            <div className="col">
                <hr />
            </div>
        </div>
        <div className="d-flex flex-column">
            {phrases && phrases.map((p, key) => (
                <span className="mt-1 mobile-top-bar-searching-result-holder-element" key={key} onClick={() => {
                    const params = new URLSearchParams(window.location.search)
                    if (p.value) {
                        params.set('q', p.value)
                    } else {
                        params.delete('q')
                    }
                    handleElementClick(`/shop?${params.toString()}`)
                }}>{CapitalizeFirstLowercaseRest(p.value)}</span>
            ))}
        </div>
    </>)
}

const Categories = ({ categories, textSearch, handleCategoryClick, setHideProductList }) => {
    const handleClick = (c) => {
        setHideProductList(true)
        handleCategoryClick(c, textSearch, null)
    }

    return (<>
        <div className="row mt-2 mb-2 align-items-center secondary-text">
            <div className="col-auto">
                <span className="" style={{ fontWeight: 'bold', fontSize: '25px' }}>Kategorie</span>
            </div>
            <div className="col">
                <hr />
            </div>
        </div>
        <div className="d-flex flex-column">
            {categories && categories.map((c, key) => (
                <span onClick={() => handleClick(c)} className="mt-1 mobile-top-bar-searching-result-holder-element" key={key}>{c.catDescription}</span>
            ))}
        </div>
    </>)
}

const Suppliers = ({ suppliers, handleSupplierClick, textSearch, setHideProductList }) => {
    const handleClick = (s) => {
        setHideProductList(true)
        handleSupplierClick(s, textSearch, null)
    }

    return (<>
        <div className="row mt-2 mb-2 align-items-center secondary-text">
            <div className="col-auto">
                <span className="" style={{ fontWeight: 'bold', fontSize: '25px' }}>Producenci</span>
            </div>
            <div className="col">
                <hr />
            </div>
        </div>
        <div className="d-flex flex-column">
            {suppliers && suppliers.map((s, key) => (
                <span onClick={() => handleClick(s)} className="mt-1 mobile-top-bar-searching-result-holder-element" key={key}>{s.supplierName}</span>
            ))}
        </div>
    </>)
}

const Products = ({ products, wholesalePrices, handleProductInQueryClick, setHideProductList }) => {
    const { GetProductImage } = useGetProductImage()
    const { addProductToBasket } = useCart()
    const { savedOfferId } = useOffers()

    const handleClick = (p) => {
        setHideProductList(true)
        handleProductInQueryClick(p.index, null)
    }

    return (<>
        <div className="row mt-2 mb-2 align-items-center secondary-text">
            <div className="col-auto">
                <span className="" style={{ fontWeight: 'bold', fontSize: '25px' }}>Produkty</span>
            </div>
            <div className="col">
                <hr />
            </div>
        </div>
        <div className="d-flex flex-column">
            {products && products.map((p, key) => {
                const priceNet = wholesalePrices ? p.priceNet : p.priceNetBase
                const priceGross = wholesalePrices ? p.priceGross : p.priceGrossBase

                return (
                    <div className="row mb-3" key={key} onClick={() => handleClick(p)}>
                        <div className="col-2" style={{ maxWidth: '180px' }}>
                            <GetProductImage
                                photoFileName={p.photoFileNames[0]}
                                imgClassName="img-fluid"
                            />
                        </div>
                        <div className="col d-flex flex-column mobile-top-bar-searching-result-holder-element">
                            <span>{CapitalizeFirstLowercaseRest(p.title)}</span>
                            <span className="secondary-color-text">{CapitalizeFirstLowercaseRest(p.label)}</span>
                        </div>
                        <div className="col-4 d-flex flex-column align-items-end">
                            <span className="primary-accent-color-text">{priceNet.toLocaleString(undefined, { minimumFractionDigits: 2 })} {p.currency}</span>
                            <span>{priceGross.toLocaleString(undefined, { minimumFractionDigits: 2 })} {p.currency}</span>
                        </div>
                        {savedOfferId == -1 && <div className="col-auto d-none d-md-flex ">
                            <IoCartOutline size={25} color='var(--primary)' onClick={(e) => {
                                e.stopPropagation() // Blokuje wywołanie onClick z rodzica                    
                                addProductToBasket(p.index, p.salesRatio)
                            }} />
                        </div>}
                    </div>
                )
            }
            )}
        </div>
    </>)
}

export default TopBarMobileSearchingResults